import { store } from '../redux/store';
import { languageConfig } from '../settings/i18n/languages';

/**
  Funkcja zwracająca tłumaczenie bezpośrednio z pliku
  // z niewiadomych przyczyn w momencie wyrzucenia 'store' rzuca błędami..
*/
export const translationFromFile = (key: string): string | null => {
  const translation = languageConfig[store.getState().AppConfig.currentLanguage].translations[key];

  return translation ? translation : null;
};
